export enum PlatformPauseDuration {
  THREE_MONTHS = '3-months',
  SIX_MONTHS = '6-months',
  TWELVE_MONTHS = '12-months',
  UNTIL_ENABLED = 'until-enabled',
}
